import BuildingType from '@/roc/building/BuildingType';
import Effects from '@/roc/effects/Effects';
import ProductionCurrency from '@/roc/effects/Production/ProductionCurrency';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import CultureBonus from '@/roc/effects/CultureBonus/CultureBonus';
import CultureAmount from '@/roc/effects/CultureBonus/CultureAmount';
import CultureRange from '@/roc/effects/CultureBonus/CultureRange';
import ProductionQueue from '@/roc/effects/Production/ProductionQueue';
import ProductionWorkforce from '@/roc/effects/Production/ProductionWorkforce';
import ProductionCost from '@/roc/effects/Production/ProductionCost';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';

const ArcGate = {
  id: '86',
  name: 'Arc Gate',
  width: 3,
  height: 2,
  type: BuildingType.COLLECTABLE,
  era: 'stoneAge',
  icon: 'Arc_Gate',
  minLevel: 1,
  maxLevel: 40,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Arc_Gate',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new CultureBonus(
      CultureAmount.asPerLevel([
        80, 120, 160, 200, 240, 280, 320, 360, 400, 440,
        480, 520, 560, 600, 640, 680, 720, 760, 800, 840,
        880, 920, 960, 1000, 1040, 1080, 1120, 1160, 1200, 1240,
        1280, 1320, 1360, 1400, 1440, 1480, 1520, 1560, 1600, 1640
      ]),
      CultureRange.asFlat(2),
    ),
    new ProductionQueue(
      ProductionWorkforce.asCallbackWithLevel(
        (level) => {
          if (level <= 9) {
            return 2;
          }
          if (level <= 19) {
            return 3;
          }
          if (level <= 29) {
            return 4;
          }
          if (level <= 39) {
            return 5;
          }
          return 6;
        }
      ),
      [
        ProductionCost.asFlat(12).withCurrency(ProductionCurrency.INFANTRY_UNITS),
      ],
      ProductionDuration.asFlat(8 * 60 * 60),
      ProductionOutput.asCallbackWithLevel(
        (level) => {
          return 150 + (level - 1) * 25;
        }
      ).withOutput(ProductionOutputType.CURRENT_ERA_PRIMARY_GOODS),
    ),
  ]),
};

export default ArcGate;
